/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import { Button, Col, Container, Row, Table } from "react-bootstrap"
import LocalAlertComponent from "../../../../components/LocalAlertComponent"
import ConfirmModal from "../../../../components/Modal/ConfirmModal"
import {
  ModalOuter,
  TModalTypes,
} from "../../../../components/Modal/ModalOuter"
import { setAlerts } from "../../../../globalStore/alertStore"
import { AppDispatch } from "../../../../"
import SyaryoSyozokuService from "../../../../service/truck/syaryoSyozoku/syaryoSyozokuService"
import { Exception } from "@zxing/library"
import TextAreaInput from "../../../../components/InputWrapper/TextAreaInput"
import { showInfoToast } from "../../../../components/CustomToast"
import { FunctionContext } from "../../../../components/Context"

/**
 * 車輌移動履歴　編集モーダル
 * @param {*} props
 * @return {*} reactNode
 */
const UpdateSyaryoIdoRirekiModal: React.FC<
  Omit<TModalTypes, "title"> & {
    title?: string
    footer?: React.ReactNode
    syaryoSyozokuId: number
    text: string
  }
> = (props) => {
  const dispatch: AppDispatch = useDispatch()
  const pageSearch = useContext(FunctionContext)
  //#region [state]

  const [isConfirmModalShow, setIsConfirmModalShow] = useState(false)
  const [車輌所属ID, set車輌所属ID] = useState<number>()
  const [備考, set備考] = useState<string>("")

  // アラート用State
  const [AlertSource, setAlertSource] = useState<any>()
  //#endregion

  //#region [method]

  const beforeSubmit = () => {
    setIsConfirmModalShow(true)
  }

  const submit = async () => {
    setAlertSource(undefined)
    try {
      const service = new SyaryoSyozokuService()
      let data = {
        車輌所属ID: props.syaryoSyozokuId,
        備考: 備考,
      }
      if (!props.syaryoSyozokuId) {
        throw new Exception()
      }
      let res = await service.putSyaryoSyozoku(props.syaryoSyozokuId, data)

      if (res.data) {
        props.setIsShow(false)
        showInfoToast(`車輌異動履歴の更新が完了しました`)
        pageSearch()
      }
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsConfirmModalShow(false)
    }
  }
  //#endregion

  //#region [effect]
  useEffect(() => {
    if (props.isShow) {
      set車輌所属ID(props.syaryoSyozokuId)
      set備考(props.text)
    }
  }, [props.isShow])
  //#endregion
  return (
    <ModalOuter
      isShow={props.isShow}
      title={props.title ?? "車輌移動履歴"}
      setIsShow={props.setIsShow}
      size={"lg"}
      footer={
        <Button
          type="submit"
          variant="waiting"
          onClick={(e) => {
            e.stopPropagation()
            e.preventDefault()
            beforeSubmit()
          }}>
          更新
        </Button>
      }>
      <Container fluid className="label-form">
        {/* アラート表示 */}
        <Row>
          <Col>
            <LocalAlertComponent alertSource={AlertSource} />
          </Col>
        </Row>
        <form>
          <Row>
            <Col>
              <div>履歴ID:{車輌所属ID}</div>
              <Table className="form-table">
                <tbody>
                  <tr>
                    <th className="min-w-8rem">備考</th>
                    <td>
                      <div className="input-group">
                        <TextAreaInput
                          style={{ width: "30rem" }}
                          id="備考"
                          name="備考"
                          value={備考}
                          setValue={set備考}></TextAreaInput>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </Table>
            </Col>
          </Row>
        </form>
      </Container>
      <ConfirmModal
        isShow={isConfirmModalShow}
        hideHandler={setIsConfirmModalShow}
        submitHandler={submit}>
        入力された内容で更新しますか？
      </ConfirmModal>
    </ModalOuter>
  )
}

export default UpdateSyaryoIdoRirekiModal
